import { createUserDataQueries } from '@astra/core/queries';
import { supabase } from '../../lib/supabaseClient';

export const {
  useUserAccess,
  useUserProgress,
  useUserAllProgress,
  useUpdateUserProfile,
  useTrackProgress,
  useQuizResponses,
  useSubmitQuizResponse,
  useOrganization,
  useOrganizationBySubdomain,
} = createUserDataQueries({ supabase });
